import React from 'react';
import PropTypes from 'prop-types';

function IconInvite({ color = `#30DD87`, className, style }) {
  return (
    <svg className={className} style={style} width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.3567 5.15385C16.1817 7.44149 14.3925 9.30769 12.4282 9.30769C10.464 9.30769 8.67164 7.44192 8.49977 5.15385C8.32121 2.77404 10.0622 1 12.4282 1C14.7942 1 16.5353 2.81731 16.3567 5.15385Z" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.4283 12.0771C8.54443 12.0771 4.60257 14.1541 3.87313 18.0743C3.78385 18.5468 4.06107 19.0002 4.57177 19.0002H20.2852C20.7959 19.0002 21.0718 18.5468 20.9838 18.0743C20.2539 14.1541 16.3121 12.0771 12.4283 12.0771Z" stroke={color} strokeWidth="1.25" strokeMiterlimit="10"/>
      <path d="M3.49993 6.53857V11.3847M5.99986 8.96165H1" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconInvite.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconInvite;
